export const version = 'kunde-v1.18.0-rc4';